import React, { useState } from "react";
import { Box, Grid, MenuItem, Select } from "@mui/material";
import { FormControl } from "@mui/material";
import StatusView from "./statusView";

function preventDefault(event) {
  event.preventDefault();
}

export default function CounterAR({
  filterSelected,
  data,
  callbackFetchDataList,
}) {
  const statusType = data;
  const handleChange = (event) => {
    const newFilterSelected = event.target.value;
    callbackFetchDataList(newFilterSelected);
  };

  return (
    <React.Fragment>
      <Box display="flex" justifyContent="end">
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <Select
            value={filterSelected || "yearly"}
            onChange={handleChange}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value="daily">Daily</MenuItem>
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
            <MenuItem value="yearly">Yearly</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={{ xs: 2, sm: 2, md: 1 }}
      >
        {statusType
          .filter((data) => data.label !== "Success") // Filter out 'others' status
          .map((data, i) => (
            <Grid item xs={12} md={6} lg={2} key={i}>
              <StatusView
                title={data.label}
                total={data.value || 0}
                icon={data.icon}
                bgColor={data.color}
              />
            </Grid>
          ))}
      </Grid>
    </React.Fragment>
  );
}
